import { keys, values, mapItems, flatten } from 'ldash';
export const TIMESTATS_COLSPEC = {
    // map timestats field names to i18n values
    default: [
        [
            'count',
            'newMetadataII'
        ]
    ],
    datatype1: [
        [
            'count',
            'newMetadataII'
        ],
        [
            'images',
            'newImagesII'
        ],
        [
            'released',
            'state_1'
        ],
        [
            'qsready',
            'qsreadycount'
        ],
        [
            'backuped',
            'backupedcount'
        ]
    ],
    datatype0: [
        [
            'count',
            'newStructures'
        ],
        [
            'folders',
            'newFolderStructures'
        ]
    ],
    datatype3: [
        [
            'count',
            'newImages'
        ],
        [
            'size',
            'sumfilesize'
        ],
        [
            'noicc',
            'iccunavailablecount'
        ],
        [
            'corrupt',
            'corruptcount'
        ]
    ],
    sysaggr: [
        [
            'count_rel_1',
            'released1'
        ],
        [
            'count_unrel_1',
            'unreleased1'
        ],
        [
            'count_rel_0',
            'released0'
        ],
        [
            'count_unrel_0',
            'unreleased0'
        ],
        [
            'count_rel_3',
            'released3'
        ],
        [
            'count_unrel_3',
            'unreleased3'
        ]
    ],
    datatype1statesCounts: [
        [
            'releasestate0',
            'releaseState0'
        ],
        [
            'releasestate1',
            'releaseState1'
        ],
        [
            'qsbegin',
            'qsstatebegin'
        ],
        [
            'qsready',
            'qsstateready'
        ],
        [
            'wfundef',
            'wfstateundef'
        ],
        [
            'wfbegin',
            'wfstatebegin'
        ],
        [
            'wfready',
            'wfstateready'
        ]
    ],
    releaseStates: [
        [
            'count_ot_state',
            'changedStatesAll'
        ],
        [
            'ot_state_1',
            'changedState_ot_state_1'
        ],
        [
            'ot_state_0',
            'changedState_ot_state_0'
        ]
    ],
    resource2: [
        [
            'count',
            'Resourcen'
        ],
        [
            'words',
            'Words'
        ],
        [
            'type_2',
            'Finereader'
        ],
        [
            'type_6',
            'ALTO'
        ],
        [
            'type_20',
            'PAGE'
        ],
        [
            'type_21',
            'Google'
        ],
        [
            'type_23',
            'HOCR'
        ],
        [
            'type_24',
            'Microsoft'
        ]
    ],
    remoteoperation: [
        [
            'count',
            'Operationen'
        ],
        [
            'ocr_finereader_0',
            'Finereader (Antiqua)'
        ],
        [
            'ocr_finereader_1',
            'Finereader (Fraktur)'
        ],
        [
            'ocr_google_0',
            'Google (OCR)'
        ],
        [
            'ner_google_0',
            'Google (NER)'
        ]
    ],
    datatype1types: [
        [
            'count',
            'newMetadataII'
        ],
        // build mapping later on data received
        ({ iconfig, tsdata })=>{
            // avail_md_subtypes is a set of int's in str form
            let avail_md_subtypes = new Set(flatten(tsdata.map((r)=>keys(r).filter((name)=>name.startsWith('t_')).map((name)=>name.slice(2)))));
            return mapItems(iconfig.itypes.byId[1], (subtype, name)=>[
                    `t_${subtype}`,
                    `types_metadata_${name}`
                ], (subtype)=>avail_md_subtypes.has(subtype));
        }
    ],
    gndotypes: [
        [
            'count',
            'Alle'
        ],
        [
            't_13',
            'name_summary'
        ],
        [
            't_16',
            'place_list'
        ],
        [
            't_19',
            'gndoSubjects'
        ]
    ]
};
export const FILTER_TIMESTATS_ROWS = {
    datatype1types_insertdate: (dtrow)=>dtrow.count > 0,
    datatype1types_releasedate: (dtrow)=>dtrow.count > 0
};
